import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { MD_MEDIA_QUERY, LG_MEDIA_QUERY } from '~shared/media-query';
import { StyleProps, StyleRules } from '~pricing/components/PackageHeader/types';

export default createMemoStyles<StyleRules, StyleProps, PricingAppTheme>(
  ({ spacing, type, pricingPalette }: PricingAppTheme) => ({
    Header: {
      textAlign: 'center',
      padding: [spacing[4], spacing[1]],
      fontSize: 16,
      '& h2': {
        // Package header text
        fontWeight: type.fontWeight.medium,
        fontSize: ({ isSummaryPage }: StyleProps) => (isSummaryPage ? '1.5em' : '1.25em'),
        marginBottom: spacing[1],
      },
      '& p': {
        // Package byline
        color: pricingPalette.colors.slate,
        marginTop: spacing[2],
        fontSize: '1em',
      },
      [MD_MEDIA_QUERY]: {
        fontSize: 12,
        minHeight: 180,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'stretch',
      },
      [LG_MEDIA_QUERY]: {
        fontSize: 16,
      },
    },
  })
);
